$('.acc-trigger').on('click', function () {
  $(this).next().stop().slideToggle();
  $(this).stop().toggleClass('is-active')
})
